import type { ReactNode } from 'react'

import {
  CommunityCardSlider,
  type TCommunityCardSliderProps,
} from '@/src/features/community/ui/components/CommunityCardSlider'
import { TEST_ID } from '@/src/general/constants/testId'
import { TRACKING_SOURCE } from '@/src/general/utils/gtm/constants'
import { useRoutes } from '@/src/general/utils/routes'
import { useTranslate } from '@/src/lang/useTranslate'

import { COMMUNITIES_CATEGORY, EVENT_ORIGIN } from '../../../models/community.constants'
import { getCommunitiesCategoryQueryParams, useCommunitiesQuery } from '../../../services/useCommunitiesQuery'

type TCurrentlyCommunitiesSectionProps = { hasFeaturedTag?: boolean } & Pick<
  TCommunityCardSliderProps,
  'classes' | 'communityCardVariant'
>

export const CurrentlyCommunitiesSection = ({
  classes,
  hasFeaturedTag = false,
  communityCardVariant,
}: TCurrentlyCommunitiesSectionProps): ReactNode => {
  const { t } = useTranslate()
  const { routes } = useRoutes()

  const { data: currentlyCommunities } = useCommunitiesQuery(
    getCommunitiesCategoryQueryParams(COMMUNITIES_CATEGORY.CURRENTLY),
  )

  if (!currentlyCommunities || currentlyCommunities.length === 0) return null

  return (
    <CommunityCardSlider
      link={routes.communitiesCategory(COMMUNITIES_CATEGORY.CURRENTLY)}
      testID={TEST_ID.COMMUNITIES.AT_THE_MOMENT_COMMUNITIES}
      title={!hasFeaturedTag ? t('words.ongoing') : t('communities.other-suggestions')}
      list={currentlyCommunities}
      origin={EVENT_ORIGIN.CURRENTLY_SECTION}
      source={TRACKING_SOURCE.CURRENTLY_SECTION}
      classes={classes}
      communityCardVariant={communityCardVariant}
    />
  )
}
